module.exports = __webpack_public_path__ + "img/Succes_G.7859fd90.png";